<template>

    <Toast/>

    <MenuHealthCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Automations</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Claim Follow-Ups</a></li>
        </ul>

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Invoice Follow-ups</h3>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">

                                <DataTable
                                    v-model:lazyParams="lazyParams"
                                    :value="payments"
                                    lazy
                                    paginator
                                    size="small"
                                    :ptOptions="{ mergeSections: true, classNameMergeStrategy: 'replace' }"
                                    :pt="{headerCell: { class: 'py-1 px-2' }, bodyCell: { class: 'p-0' }, bodyRow: { class: 'p-0' }}"
                                    :rows="10"
                                    :totalRecords="totalRecords"
                                    :loading="loading"
                                    :rowsPerPageOptions="[10, 20, 50, 100]"
                                    :sortMode="'single'"
                                    :rowHover="true"
                                    :striped-rows="true"
                                    :reorderableColumns="true"
                                    filterDisplay="menu"
                                    responsiveLayout="scroll"
                                    :globalFilterFields="['id', 'uniqueId', 'clientName', 'paid', 'description', 'amount']"
                                    @page="onPage"
                                    @sort="onSort"
                                    @filter="onFilter">

                                    <template #header>
                                        <div class="p-grid">
                                            <div class="grid">
                                                <div class="col-12 lg:col-6 p-2">
                                                    <MultiSelect :modelValue="selectedColumns"
                                                                 :options="columnsFullList"
                                                                 optionLabel="header"
                                                                 @update:modelValue="onToggleColumns"
                                                                 display="chip"
                                                                 placeholder="Select Columns"/>
                                                </div>
                                                <div class="col-12 lg:col-6 p-2">
                                                    <Dropdown v-model="selectedStandardFilter"
                                                              :options="statusTypesLimited"
                                                              optionLabel="name" optionValue="code"
                                                              placeholder="Select a Filter"
                                                              @update:modelValue="onToggleStandardFilters"/>
                                                </div>

                                            </div>

                                            <div class="grid">
                                                <div class="col-12 lg:col-6 p-2">
                                                    <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                            class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                                </div>
                                                <div class="col-12 lg:col-6 p-2">
                                                    <Button type="button" icon="pi pi-replay"
                                                            label="Restore to Original View"
                                                            class="p-button-outlined" @click="restoreToOriginal()"/>
                                                </div>
                                            </div>

                                            <div class="p-col-12 p-md-2">
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search"/>
                                                    <InputText v-model="filters['global'].value"
                                                               placeholder="Keyword Search on Payment ID, Invoice ID, Client Name, Payment Date, Description or Amount (Please press enter to search)"
                                                               style="width: 100%"
                                                               @keyup.enter="onSearch"/>

                                                </span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #empty>
                                        No invoice follow-ups found.
                                    </template>

                                    <template #loading>
                                        Loading invoice follow-ups. Please wait.
                                    </template>

                                    <Column :headerStyle="{ width: '2rem' }"
                                            :bodyStyle="{ width: '2rem', padding: '0.25rem' }"
                                            field="selectAnOption" style="width: 5%">
                                        <template #body="{ data }">
                                            <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                                    class="p-button-rounded p-button-danger m-1"
                                                    @click="callDeletePayment(data)"/>
                                        </template>
                                    </Column>

                                    <Column :headerStyle="{ width: '2rem' }"
                                            :bodyStyle="{ width: '10rem', padding: '0.25rem' }"
                                            field="paid" header="Payment Date" :sortable="true"/>

                                    <template v-for="col in selectedColumns" :key="col.field">

                                        <Column :headerStyle="{ width: '2rem' }"
                                                :bodyStyle="{ width: '10rem', padding: '0.25rem' }"
                                                v-if="col.field === 'status'" :field="col.field" :header="col.header"
                                                :sortable="col.sortable">
                                            <template #body="{ data }">
                                                <span class="p-column-title">Status</span>
                                                <span v-if="data.status === 'I'"
                                                      :class="'status-badge status-' + data.status">Initialised</span>
                                                <span v-if="data.status === 'P'"
                                                      :class="'status-badge status-' + data.status">Fully Allocated</span>
                                                <span v-if="data.status === 'A'"
                                                      :class="'status-badge status-' + data.status">Partially
                                                    Allocated</span>
                                            </template>
                                        </Column>

                                        <Column :headerStyle="{ width: '2rem' }"
                                                :bodyStyle="{ width: '10rem', padding: '0.25rem' }"
                                                v-else-if="col.field === 'type'" :field="col.field" :header="col.header"
                                                :sortable="col.sortable">
                                            <template #body="{ data }">
                                                <span class="p-column-title">Type</span>
                                                <span v-if="data.type === 'C'"
                                                      :class="'type-badge status-' + data.type">Credit Card</span>
                                                <span v-if="data.type === 'B'"
                                                      :class="'type-badge status-' + data.type">Bank Transfer</span>
                                                <span v-if="data.type === 'H'"
                                                      :class="'type-badge status-' + data.type">Health Insurance</span>
                                                <span v-if="data.type === 'R'"
                                                      :class="'type-badge status-' + data.type">Cryptocurrency</span>
                                                <span v-if="data.type === 'A'"
                                                      :class="'type-badge status-' + data.type">Cash</span>
                                                <span v-if="data.type === 'O'"
                                                      :class="'type-badge status-' + data.type">Other</span>
                                                <span v-if="data.type === 'W'"
                                                      :class="'type-badge status-' + data.type">Write-Off</span>
                                            </template>
                                        </Column>

                                        <Column :headerStyle="{ width: '2rem' }"
                                                :bodyStyle="{ width: '10rem', padding: '0.25rem' }"
                                                v-else-if="col.field === 'amount'" :field="col.field"
                                                :header="col.header" :sortable="col.sortable">
                                            <template #body="{ data }">
                                                <span class="p-column-title">Amount</span>
                                                {{ formatAmount(data.amount) }}
                                            </template>
                                        </Column>

                                        <Column :headerStyle="{ width: '2rem' }"
                                                :bodyStyle="{ width: '10rem', padding: '0.25rem' }"
                                                v-else :field="col.field" :header="col.header"
                                                :sortable="col.sortable"/>

                                    </template>

                                </DataTable>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Payment {{ this.payment.id }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Payment?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deletePayment"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import CompanyService from "@/service/CompanyService";
import PaymentService from "@/service/PaymentService";
import numeral from "numeral";
import axios from "axios";
import PaymentImportService from "../../service/PaymentImportService";

export default {
    components: {
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();

        this.columnsDefault = [
            {field: 'id', header: 'Payment #', sortable: true},
            {field: 'uniqueId', header: 'Invoice #', sortable: false},
            {field: 'amount', header: 'Amount', sortable: true},
            {field: 'status', header: 'Status', sortable: true},
            {field: 'type', header: 'Type', sortable: true},
            {field: 'clientName', header: 'Client Name', sortable: true},
        ];

        this.columnsFullList = [
            {field: 'id', header: 'Payment #', sortable: true},
            {field: 'uniqueId', header: 'Invoice #', sortable: false},
            {field: 'amount', header: 'Amount', sortable: true},
            {field: 'status', header: 'Status', sortable: true},
            {field: 'type', header: 'Type', sortable: true},
            {field: 'clientName', header: 'Client Name', sortable: true},
            {field: 'description', header: 'Description', sortable: true},
            {field: 'appointmentDate', header: 'Appointment Date', sortable: true},
            {field: 'practitionerName', header: 'Practitioner', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

        this.standardFilters = [
            {field: 'unallocated', header: 'Unallocated'},
            {field: 'fullyAllocated', header: 'Fully Allocated'},
            {field: 'partiallyAllocated', header: 'Partially Allocated'}
        ];

    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[Payments][mounted] System is active.");
            console.log("[Payments][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[Payments][mounted] System is NOT active.");
            console.log("[Payments][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[Payments][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();
    },
    data() {

        return {
            totalRecords: 0,
            loading: false,
            lazyParams: {
                first: 0,
                rows: 10,
                sortField: null,
                sortOrder: null,
                filters: {}
            },
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            userConfiguration: {},
            filters: null,
            submitted: false,
            filteredItemsCache: new Map(),
            payment: {},
            payments: null,
            originalPayments: null,
            importedPayment: {},
            importedPaymentComponents: [],
            confirmationResponse: 'N',
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            standardFilters: null,
            inputPassword: null,
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'}
            ],
            statusTypesLimited: [
                {name: 'All', code: 'C'},
                {name: 'Fully Paid', code: 'P'},
                {name: 'Partially Paid', code: 'A'},
                {name: 'Unpaid', code: 'I'}
            ],
            inputFormat: null,
            file: null, // Holds the selected file
            url: "/payment1/import/healthinsurance/discovery/1", // URL for API call
            fileAccept: '.csv, application/pdf', // Accept CSV and PDF files
            inputFormats: [
                // {name: 'Discovery Health Insurance Statement (PDF)', code: '001'},
                {name: 'ABSA Bank Statement (PDF)', code: '003'},
                {name: 'FNB Bank Statement (PDF)', code: '004'},
                {name: 'Generic Bank Statement (CSV)', code: '006'}
                // {name: 'Generic Health Insurance Statement (CSV)', code: '002'},
                // {name: 'ABSA Credit Card Statement (PDF)', code: '005'},
            ],
        }
    },
    watch: {
        payments() {
            this.filteredItemsCache.clear();
        },
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    computed: {
        isBankStatement() {
            return this.importedPaymentComponents.some(payment => payment.type === "B");
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                try {
                    // Attempt to get user data
                    const userData = await UserService.getUser(this.userStore.user.id);
                    this.profile = userData.data;
                } catch (e) {
                    console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                    this.userStore.clearUser();
                    this.$router.push('login');
                    return;
                }

                this.profile.companyId = this.userStore.activeCompanyId;

                const [userConfigurationData, companyConfigurationData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id),
                    CompanyService.getCompanyConfiguration(this.profile.companyId),
                ]);

                this.userConfiguration = userConfigurationData.data;
                this.companyConfiguration = companyConfigurationData.data;

                await this.loadData();

                this.loading = false;

            } catch (e) {
                console.error("[Payments][mounted] Error fetching additional data = ", e);
            }

            console.log("[Payments][mounted] this.payments = ", this.payments);
            console.log("[Payments][mounted] this.userConfiguration = ", this.userConfiguration);
            console.log("[Payments][mounted] this.companyConfiguration = ", this.companyConfiguration);
        },
        async loadData() {
            this.loading = true;
            try {
                console.log("[Payments][loadData] Fetching clients with params:", this.lazyParams, "Search:", this.filters['global']?.value);

                if (this.userStore.user.rights === 'M') {
                    const response = await PaymentService.getPractitionerPaymentsLazyLoading(
                        this.profile.companyId,
                        this.userStore.user.practitionerId,
                        this.lazyParams,
                        this.filters['global']?.value || '',
                        this.selectedStandardFilter, null, null);

                    console.log("[Payments][loadData] API Response:", response);
                    console.log("[Payments][loadData] response.data.content:", response.data?.content);
                    console.log("[Payments][loadData] response.data.totalElements:", response.data?.totalElements);

                    this.payments = Array.isArray(response.data.content) ? response.data.content : [];
                    this.originalPayments = this.invoices;

                    this.totalRecords = response.data?.totalElements || 0;

                    console.log("[Payments][loadData] Clients Updated:", this.clients, "Total Records:", this.totalRecords);

                } else {
                    const response = await PaymentService.getCompanyPaymentsLazyLoading(
                        this.profile.companyId,
                        this.lazyParams,
                        this.filters['global']?.value || '',
                        this.selectedStandardFilter, null, null);

                    console.log("[Payments][loadData] API Response:", response);
                    console.log("[Payments][loadData] response.data.content:", response.data?.content);
                    console.log("[Payments][loadData] response.data.totalElements:", response.data?.totalElements);

                    this.payments = Array.isArray(response.data.content) ? response.data.content : [];
                    this.originalPayments = this.invoices;

                    this.totalRecords = response.data?.totalElements || 0;

                    console.log("[Payments][loadData] Clients Updated:", this.clients, "Total Records:", this.totalRecords);
                }

            } catch (error) {
                console.error("[Payments][loadData] Error loading payments:", error);
                this.payments = [];
                this.originalPayments = [];
                this.totalRecords = 0;
            }
            this.loading = false;
        },
        onPage(event) {
            console.log("[Payments][onPage] Page Event:", event);
            this.lazyParams.first = event.first;
            this.lazyParams.rows = event.rows;
            this.loadData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            this.loadData();
        },
        onFilter(event) {
            this.lazyParams.filters = event.filters;
            this.loadData();
        },
        onSearch() {
            console.log("[Payments][onSearch] Searching with:", this.filters['global'].value);
            this.lazyParams.first = 0;
            this.loadData();
        },
        onToggleStandardFilters() {
            console.log("[Payments][onToggleStandardFilters] Applying Standard Filter:", this.selectedStandardFilter);
            this.lazyParams.first = 0;
            this.loadData();
        },
        clearFilter() {
            this.initFilters();
            this.lazyParams.filters = {}; // Clear all column filters
            this.lazyParams.first = 0; // Reset pagination to first page
            this.loadData();
        },
        restoreToOriginal() {
            this.initFilters();
            this.lazyParams.filters = {}; // Clear all column filters
            this.lazyParams.first = 0; // Reset pagination to first page
            this.loadData();
            // window.location.reload();
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'uniqueId': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'clientName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'paid': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'description': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'amount': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        // clearFilter() {
        //     this.initFilters();
        // },
        // restoreToOriginal() {
        //     window.location.reload();
        // },
        callReset() {
            this.activeTab = 1;
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        // onToggleStandardFilters(value) {
        //
        //     if (value.length > 1) {
        //         // Keep the last selected option
        //         this.selectedStandardFilter = [value[value.length - 1]];
        //     } else {
        //         this.selectedStandardFilter = value;
        //     }
        //
        //     const isUnallocated = value.some(item => item.field === "unallocated");
        //     const isFullyAllocated = value.some(item => item.field === "fullyAllocated");
        //     const isPartiallyAllocated = value.some(item => item.field === "partiallyAllocated");
        //
        //     if (this.payments !== null) {
        //
        //         if (isUnallocated) {
        //             this.payments = this.originalPayments.filter(payment => payment.status === 'I');
        //         } else if (isFullyAllocated) {
        //             this.payments = this.originalPayments.filter(payment => payment.status === 'P');
        //         } else if (isPartiallyAllocated) {
        //             this.payments = this.originalPayments.filter(payment => payment.status === 'A');
        //         } else {
        //             this.payments = this.originalPayments;
        //         }
        //
        //     } else {
        //         // Handle the case when auditTrails is null
        //         this.payments = null;
        //     }
        // },
        getFilteredItems(data) {
            if (this.filteredItemsCache.has(data.id)) {
                return this.filteredItemsCache.get(data.id);
            }

            const items = [];

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callDeletePayment(data);
                }
            });

            this.filteredItemsCache.set(data.id, items);

            return items;
        },
        chooseBlankSelection(data) {
            console.log('[Payments][chooseBlankSelection] data = ', data);
            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a valid option.',
                life: 3000
            });
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            }
        },
        callImportPayments() {
            this.activeTab = 3;
            this.inputFormat = '001';
        },
        callResetImportPayments() {
            this.activeTab = 1;
            this.file = null;
            this.file.value = null;
            this.inputFormat = '001';
        },
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        async submitFile() {
            this.submitted = true;

            if (!this.file) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });

                // alert("Please select a file first!");
                // return;
            }

            console.log('[Payments][submitFile] this.inputFormat = ', this.inputFormat);

            const formData = new FormData();
            formData.append('file', this.file);

            var url = "/api/paymentimport/import/generic/" + this.profile.companyId;

            // if (this.inputFormat == "002") {
            //     url = "/api/financialtransaction/import/bank/absa/" + this.profile.companyId;
            // }

            if (this.inputFormat == "001") {
                url = "/api/paymentimport/import/healthinsurance/discovery/pdf/" + this.profile.companyId;
            } else if (this.inputFormat == "002") {
                url = "/api/paymentimport/import/bankstatement/generic/csv/" + this.profile.companyId;
            } else if (this.inputFormat == "003") {
                url = "/api/paymentimport/import/bankstatement/absa/pdf/" + this.profile.companyId + "/" + this.inputPassword;
            } else if (this.inputFormat == "004") {
                url = "/api/paymentimport/import/bankstatement/fnb/pdf/" + this.profile.companyId + "/" + this.inputPassword;
            } else if (this.inputFormat == "005") {
                url = "/api/paymentimport/import/creditcardstatement/absa/pdf/" + this.profile.companyId + "/" + this.inputPassword;
            } else if (this.inputFormat == "006") {
                url = "/api/paymentimport/import/bankstatement/generic/csv/" + this.profile.companyId;
            }

            console.log('[Payments][submitFile] url = ', url);
            console.log('[Payments][submitFile] this.userStore = ', this.userStore);
            console.log('[Payments][submitFile] this.userStore.accessToken = ', this.userStore.accessToken);

            try {
                const response = await axios.post(url, formData, {
                    headers: {
                        'Authorization': `Bearer ${this.userStore.accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log('Upload successful:', response.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Loaded payments',
                    life: 3000
                });

                this.importedPayment = response.data;
                this.importedPaymentComponents = response.data.components;
                console.log('[Payments][submitFile] this.importedPayment = ', this.importedPayment);
                console.log('[Payments][submitFile] this.importedPaymentComponents = ', this.importedPaymentComponents);
                this.activeTab = 4;
                // Handle the response as needed
            } catch (error) {
                console.error('Error uploading file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'File upload NOT successful',
                    life: 3000
                });

                // Handle the error as needed
            }

            this.file = null;
            this.submitted = false;
        },
        callDeletePayment(payment) {
            this.payment = {...payment};
            this.confirmationResponse = 'N';
            this.activeTab = 2;
        },
        async importFinancialTransactions() {
            this.submitted = true;

            try {
                if ((this.inputFormat === "003") || (this.inputFormat === "004") || (this.inputFormat === "005") ||
                    (this.inputFormat === "006")) {
                    const response = await PaymentImportService.importFinancialTransactions(this.profile.companyId, 'B',
                        this.importedPayment);
                    console.log('[Payments][importFinancialTransactions] Response = ', response);

                } else {
                    const response = await PaymentImportService.importFinancialTransactions(this.profile.companyId, 'H',
                        this.importedPayment);
                    console.log('[Payments][importFinancialTransactions] Response = ', response);

                }

                const [paymentData] = await Promise.all([
                    PaymentService.getCompanyPayments(this.profile.companyId)
                ]);

                this.payments = paymentData.data;
                this.originalPayments = paymentData.data;
                this.userStore.setPayments(paymentData.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Imported financial transactions',
                    life: 3000
                });

            } catch (error) {
                console.error('[Payments][deletePayment] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to import financial transactions. Please try again.',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async deletePayment() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.payment.id) {

                    try {
                        const response = await PaymentService.deletePayment(this.payment.id);
                        console.log('[Payments][deletePayment] Response = ', response);

                        const [paymentData] = await Promise.all([
                            PaymentService.getCompanyPayments(this.profile.companyId)
                        ]);

                        this.payments = paymentData.data;
                        this.originalPayments = paymentData.data;
                        this.userStore.setPayments(paymentData.data);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted payment',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[Payments][deletePayment] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete payment. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 1;
            this.submitted = false;
        }
    },
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.status-badge,
.type-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-P {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-A {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-S {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-F {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-M {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-H {
        background: #FFD8B2;
        color: #805B36;
    }

    &.status-W {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-I {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-A {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-R {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-A {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-M {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-N {
        background: #FFCDD2;
        color: #C63737;
    }

}

.type-badge {
    &.status-C {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-B {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-H {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-R {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-A {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-O {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-W {
        background: #FEEDAF;
        color: #8A5340;
    }

}

.tabview-custom {

    i,
    span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.accordion-custom {

    i,
    span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-accordion p {
    line-height: 1.5;
    margin: 0;
}

.mb-2 {
    margin-bottom: 1rem;
}

.mr-2 {
    margin-right: 1rem;
}
</style>
